import {
  Avatar,
  Fab,
  Fade,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Slide,
  TextField,
  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Search from '@material-ui/icons/Search';
import classnames from 'classnames';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import { Link } from 'react-router-dom';
import { withAplicacao } from '../../../contexts/AplicacaoContext';
import IntegrationAutosuggest from '../../share/IntegrationAutosuggest';
import LinearProgressBlockScreen from '../../share/LinearProgressBlockScreen';
import LongMenu from '../../share/LongMenu';
import VariantSnackbar from '../../share/VariantSnackbar';
import TaxaApi from '../../../api/TaxaApi';
import FormDialogTaxa from './FormDialogTaxa';
import ToolbarNovo from './ToolbarNovo';
import Edit from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AlertDialogSlide from '../../share/AlertDialogSlide';


const styles = theme => ({
  searchIcon: {
    marginRight: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1),
    marginRight: theme.spacing(10),
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  fontTable: {
    fontSize: 12
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12
  },
  formControlAutoCompleteBenef: {
    margin: theme.spacing(1),
    minWidth: 300,
  },
  selectTipoTaxa: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(2),
    width: 500,
  },
  selectTabela: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(2),
    width: 200,
  },
  selectTiposItem: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(2),
    width: 300,
  },
  tableRowProcessado: {
    backgroundColor: 'rgb(223, 240, 216)',
  },
  tableRowCancelado: {
    backgroundColor: '#f2dede',
  },
  tableRowAnalisado: {
    backgroundColor: '#d0edf4',
  },
  iconButton: {
    marginBottom: theme.spacing(1),
  },
  formControlAutoCompletePrestador: {
    marginLeft: theme.spacing(1),
    minWidth: 500,
  },
});

class TaxasCadastro extends React.Component {
  taxaApi = new TaxaApi();
  state = {
    taxas: [],
    taxaSelecionada: {},
    fetching: false,
    fetchingInicio: false,
    seqPrestadorSelected: 0,
    prestadores: [],
    tiposItem: [],
    tabelas: [],
    tiposTaxa: [],
    codTipoTaxaSelected: 0,
    codTabelaSelected: 0,
    codTipoItemSelected: 0,
    codItemTaxaSelected: 0,
    isEditavel: true,
    modoInclusao: true,
    tituloFormDialog: '',
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    openDialogTaxa: false,
    openDialogExcluirTaxa: false,
    dialogTitle: '',
    dialogContent: '',
    dialogMessage: '',
    sucesso: true,
    anchorEl: null,    
  }

  componentDidMount = async () => {
    this.setState({fetchingInicio: true});
    await this.consultarPrestadores();
    await this.consultarTabelas();
    await this.consultarTiposDeItem();
    await this.consultarTiposDeTaxa();
    this.setState({fetchingInicio: false});
  }

  consultarPrestadores = async () => {
    let prestadores = await this.props.getPrestadores();
    this.setState({ prestadores: prestadores });
  }
  consultarTabelas = async () => {
    let tabelas = await this.props.getItemTabelaTabelas();
    this.setState({tabelas: tabelas});
  }
  consultarTiposDeItem = async () => {
    let tiposItem = await this.props.getItemTabelaTipos();
    this.setState({tiposItem: tiposItem});
  }
  consultarTiposDeTaxa = async () => {
    let tiposTaxa = await this.props.getTiposTaxa();
    this.setState({tiposTaxa: tiposTaxa});
  }
  handleClickBuscar = async () => {
    this.setState({taxas: [], fetching: true});
    const filtro = {
      codItemTaxa: this.state.codItemTaxaSelected,
      codTipoTaxa: this.state.codTipoTaxaSelected,
      codTabela: this.state.codTabelaSelected,
      codTipoItem: this.state.codTipoItemSelected,
      seqPrestador: this.state.seqPrestadorSelected === undefined || this.state.seqPrestadorSelected === '' ? 0 : this.state.seqPrestadorSelected,
    };
    await this.consultarTaxas(filtro);
    this.setState({fetching: false});
  }
  consultarTaxas = async (filtro) => {
    this.setState({taxas: [], fetching: true});
    const taxas = await this.taxaApi.consultarTaxas(filtro.codItemTaxa, filtro.codTipoTaxa, filtro.codTabela, filtro.codTipoItem, filtro.seqPrestador);
    this.setState({ taxas: taxas, fetching: false });
  }

  handleChange = event => {
    this.setState({[event.target.name]: event.target.value});
  }
  getSuggestionValuePrestador = (suggestion, id) => {
    this.setState({
      seqPrestadorSelected: id !== undefined ? id : suggestion.id,
    });
    return suggestion.nome;
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }

  handleClickMenu = (event, tableMeta) => {
    const taxaSelecionada = {
      codItemTaxa: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][0],
      nomTipoTaxa: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][1],
      desTaxa: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][2],
      codTipoTaxa: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][3],
      taxaItemTabela: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][4],
      arrayItensTabela: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][5],
      taxaValor: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][6],
      arrayValores: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][7],
      indAtivaFormat: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][8],
      indAtiva: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][9],
      taxaPrestador: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][11],
      indPodeExcluir: this.state.taxas[tableMeta.currentTableData[tableMeta.rowIndex].index][12],
    };
    this.setState({ anchorEl: event.currentTarget, taxaSelecionada: taxaSelecionada });
  }

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  }

  handleChangeMenu = (index) => {
    this.setState({anchorEl: null});
    if (index === 0) {
      this.setState({openDialogTaxa: true, 
        tituloFormDialog: 'Visualizar Taxa - ' + this.state.taxaSelecionada.codItemTaxa, modoInclusao: false, isEditavel: false});
    }
    if (index === 1) {
      this.setState({openDialogTaxa: true, 
        tituloFormDialog: 'Editar Taxa - ' + this.state.taxaSelecionada.codItemTaxa, modoInclusao: false, isEditavel: true});
    }
    if (index === 2) {
      if (this.state.taxaSelecionada.indPodeExcluir === 'S'){
        this.setState({openDialogExcluirTaxa: true, dialogMessage: 'Confirma a exclusão desta taxa?',
          dialogTitle: 'Excluir Taxa - ' + this.state.taxaSelecionada.codItemTaxa});
      } else {
        this.setState({
          snackOpen: true,
          snackMessage: 'Não é possível excluir esta taxa. Ela já está vinculada a algum faturamento.',
          fetching: false,
          snackSucesso: false});

      }
    }
  }

  handleClickIncluir = () => {
    this.setState({openDialogTaxa: true, tituloFormDialog: 'Inclusão de Taxa', taxaSelecionada: {}, modoInclusao: true, isEditavel: true});
  }

  handleCloseDialogTaxa = () => {
    this.setState({openDialogTaxa: false});
  };
  handleCloseDialogExclusao = () => {
    this.setState({openDialogExcluirTaxa: false});
  };
  handleDialogConfirmExclusao = async () => {
    await this.excluirTaxa();
  }

  incluirTaxa = async (taxa) => {
    this.setState({fetching: true, taxaSelecionada: {}});
    const result = await this.taxaApi.incluirTaxa(taxa);
    if (result !== undefined && result.data !== undefined && result.data.codigoRetorno === 1) {
      await this.setState({codItemTaxaSelected: Number(result.data.registrosSemErros[0])});
    } else {
      await this.setState({codItemTaxaSelected: 0});
    }
    await this.onOperacaoFinalizada(result);
  }
  alterarTaxa = async (taxa) => {
    console.log('taxa => ' + taxa.taxaValor.length);
    const result = await this.taxaApi.alterarTaxa(taxa);
    if (result !== undefined && result.data !== undefined && result.data.codigoRetorno === 1) {
      await this.setState({codItemTaxaSelected: Number(result.data.registrosSemErros[0])});
    } else {
      await this.setState({codItemTaxaSelected: 0});
    }
    await this.onOperacaoFinalizada(result);
  }
  excluirTaxa = async () => {
    this.setState({fetching: true, openDialogExcluirTaxa: false, codItemTaxaSelected: this.state.taxaSelecionada.codItemTaxa});
    let result = await this.taxaApi.excluirTaxa(this.state.taxaSelecionada.codItemTaxa);
    await this.onOperacaoFinalizada(result);
  }

  onOperacaoFinalizada = async (result) => {
    if (result === undefined || result.data === undefined) {
      this.setState({
        snackOpen: true,
        snackMessage: 'Não foi possível realizar a operação. Favor tentar novamente.',
        fetching: false,
        snackSucesso: false});
    } else {
      if (result.data.codigoRetorno === 1) {
        this.setState({ snackOpen: true,
          snackMessage: result.data.msgRetornoResumida,
          snackSucesso: true});
          const filtro = {
            codItemTaxa: this.state.codItemTaxaSelected,
            codTipoTaxa: this.state.codTipoTaxaSelected,
            codTabela: this.state.codTabelaSelected,
            codTipoItem: this.state.codTipoItemSelected,
            seqPrestador: this.state.seqPrestadorSelected === undefined || this.state.seqPrestadorSelected === '' ? 0 : this.state.seqPrestadorSelected,
          };
          await this.consultarTaxas(filtro);
          this.setState({fetching: false});      
      } else {
        this.setState({
          openDialogValidacao: true,
          dialogContent: result.data.registrosComErros,
          dialogTitle: result.data.msgRetornoResumida,
          registrosSemErros: result.data.registrosSemErros,
          fetching: false});
      }
    }
  }
  render () {
    const options = {
      customToolbar: () => (
        <ToolbarNovo
          handleClickIncluir={this.handleClickIncluir}
        />
      ),
      setRowProps: (row) => {
        return {
          title: row[2],
          className: classnames(
            {
              [this.props.classes.tableRowCancelado]: row[8] !== 'SIM'
            }, this.props.classes.tableRow),
        };
      },
      print: true,
      download: true,
      filterType: 'dropdown',
      selectableRows: 'none',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline'}}>registro(s) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Código da Taxa',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Nome Taxa',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Descrição',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'codTipoTaxa',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'taxaItemTabela',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Itens aos quais a taxa se aplica',
        options: {
          filter: true,
          filterType: 'multiselect',
          customBodyRender: (value) => {
            return value.length === 0 ? <Typography>Taxa sem Item Específico</Typography>
              : value.map((val, key) => {
                return <Typography style={{display: 'block'}} key={key}>{val}</Typography>;
              });
          }
        }
      },      
      {
        name: 'taxaValor',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Valores da Taxa',
        options: {
          filter: true,
          filterType: 'multiselect',
          customBodyRender: (value) => {
            return value.length === 0 ? <Typography>Taxa sem Valores</Typography>
              : value.map((val, key) => {
                return <Typography style={{display: 'block'}} key={key}>{val}</Typography>;
              });
          }
        }
      },      
      {
        name: 'Ativo',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'indAtiva',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        options: {
          name: 'Ações',
          filter: false,
          sort: false,
          customHeadLabelRender: () => {
            return <Typography style={{fontSize: 13}}>Ações</Typography>;
          },
          customBodyRender: (value, tableMeta) => {
            let options = [
              {
                index: 0,
                icon: <VisibilityIcon />,
                primaryText: 'Ver Detalhes...',
                visible: true,
                disabled: false
              },
              {
                index: 1,
                icon: <Edit />,
                primaryText: 'Editar Taxa...',
                visible: true,
                disabled: false
              },
              {
                index: 2,
                icon: <DeleteIcon />,
                primaryText: 'Excluir Taxa...',
                visible: true,
                disabled: false
              },
            ];
            return (
              <LongMenu
                menuOptions={options}
                anchorEl={this.state.anchorEl}
                handleClick={this.handleClickMenu}
                handleChange={this.handleChangeMenu}
                handleClose={this.handleCloseMenu}
                selectedItem={tableMeta} />
            );
          },
        }
      },
      {
        name: 'taxaPrestador',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'indPodeExcluir',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },

    ];
    const { classes } = this.props;
    const { fetching, fetchingInicio, prestadores, taxas, 
    tiposItem, tiposTaxa, tabelas, codTipoTaxaSelected, codTabelaSelected, codTipoItemSelected } = this.state;
    return (
      <React.Fragment>
        <Link to='/tabelasApoio' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='h5'>Manter Taxas</Typography>
              <Avatar className={classes.avatar}>{taxas.length}</Avatar>
            </Paper>
          </Slide>
        </Link>
        {fetchingInicio ? <LinearProgressBlockScreen />
          : <Paper className={classes.body} elevation={1}>
             <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' 
              className={classes.selectTipoTaxa}
              >
                Tipo da Taxa
              </InputLabel>
              <Select
                className={classes.selectTipoTaxa}
                value={codTipoTaxaSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTipoTaxaSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODOS</MenuItem>
                {tiposTaxa.map((tipo, idx) => {
                  return (<MenuItem key={idx} value={tipo.id}>{tipo.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>  
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' 
              className={classes.selectTabela}
              >
                Tabela
              </InputLabel>
              <Select
                className={classes.selectTabela}
                value={codTabelaSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTabelaSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODOS</MenuItem>
                {tabelas.map((tipo, idx) => {
                  return (<MenuItem key={idx} value={tipo.id}>{tipo.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>  
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' 
              className={classes.selectTiposItem}
              >
                Tipos de Item
              </InputLabel>
              <Select
                className={classes.selectTiposItem}
                value={codTipoItemSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTipoItemSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODOS</MenuItem>
                {tiposItem.map((tipo, idx) => {
                  return (<MenuItem key={idx} value={tipo.id}>{tipo.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>  
            <FormControl>
              <Fab
                variant='extended'
                title='Buscar'
                type='submit'
                onClick={this.handleClickBuscar}
                onTouchStart={this.handleClickBuscar}
                className={classes.button}>
                <Search className={classes.searchIcon} />
                Buscar
              </Fab>
            </FormControl>

            <FormControl className={classes.formControlAutoCompletePrestador}>
              <IntegrationAutosuggest
                getSuggestionValue={this.getSuggestionValuePrestador}
                suggestions={prestadores}
                maxSuggestions={3}
                placeholder={'Digite o nome do prestador...'} />
            </FormControl>
          </Paper>
        }
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={taxas}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>}
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.snackSucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
          {this.state.openDialogTaxa &&
          <FormDialogTaxa 
          titulo={this.state.tituloFormDialog}
          taxa={this.state.taxaSelecionada}
          tiposTaxa={tiposTaxa}
          tabelas={tabelas}
          tiposItem={tiposItem}
          open={this.state.openDialogTaxa}
          modoInclusao={this.state.modoInclusao}
          isEditavel={this.state.isEditavel}
          handleClose={this.handleCloseDialogTaxa}
          handleSave={this.state.modoInclusao ? this.incluirTaxa : this.alterarTaxa}
          />}
          {this.state.openDialogExcluirTaxa &&
          <AlertDialogSlide 
          open={this.state.openDialogExcluirTaxa}
          handleClose={this.handleCloseDialogExclusao}
          handleClick={this.handleDialogConfirmExclusao}
          title={this.state.dialogTitle}
          message={this.state.dialogMessage}
          />
          }
      </React.Fragment>
    );
  }
}
export default withAplicacao(withStyles(styles)(TaxasCadastro));
